import React from "react";

function AlphabetJumpBar({ availableLetters, activeLetter }) {
  const handleClick = (letter) => {
    const el = document.getElementById(`letter-${letter}`);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="flex flex-col items-center gap-y-[2px]">
      {availableLetters.map((letter) => (
        <button
          type="button"
          key={letter}
          aria-label={`Jump to ${letter}`}
          className={`text-[16px] font-display font-bold cursor-pointer w-[32px] h-[28px] flex items-center justify-center transition-all duration-200 ${
            letter === activeLetter
              ? "text-dupontBlue dark:text-darkGold bg-dupontGold/25 dark:bg-darkGold/20 rounded-full scale-125"
              : "text-dupontGold/60 hover:text-dupontBlue dark:hover:text-darkGold"
          }`}
          onClick={() => handleClick(letter)}
        >
          {letter}
        </button>
      ))}
    </div>
  );
}

export default AlphabetJumpBar;
